<script setup lang="ts">
import { useHead } from "@unhead/vue";
import appConfig from "../lib/appConfig";
import NotFound from "../assets/vectors/not_found.svg";

useHead({
  title: appConfig.strings.app_name,
});
</script>

<template>
  <div class="bg-background-secondary min-h-screen pt-20 px-4">
    <div class="bg-background-primary max-w-md mx-auto rounded-xl">
      <div class="px-4 py-6 md:py-10">
        <NotFound class="mx-auto mb-8" />
        <div class="text-center">
          <h2 class="font-black text-2xl mb-2">
            {{ $t("404_page.title") }}
          </h2>
          <p class="opacity-60">
            {{ $t("404_page.description") }}
          </p>
          <RouterLink class="btn-primary mt-6" to="/">
            {{ $t("404_page.button") }}
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>
